<template>
  <v-card flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container pb-2">
        <h4>Breddning</h4>
      </v-card>
    </v-card>

    <v-card-text class="mt-6 mb-0 pb-0">
      <v-select
        data-cy="select-course-profession"
        v-model="profession"
        :items="professions"
        item-text="name"
        item-value="id"
        outlined
        label="Yrke"
        return-object
      />
    </v-card-text>

    <v-card-text v-if="professionName">
      <h5 class="mb-1" style="font-size: 28px !important">Breddningsregler för {{ professionName }}</h5>
      <div class="grey-text"  style="font-size: 16px !important">{{ professionType }}</div>
    </v-card-text>

    <template v-for="(toProf,i) in toProfessions">
      <ProfessionWidening :key="i" :toProfession="toProf" @edit="showDialog(...arguments)" />
    </template>

    <ProfessionWideningDialog :toProfession="editData" :show="editDialog" @cancel="hideDialog" @save="save(...arguments)" />

  </v-card> 
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProfessionWidening from '@/components/admin/widening/ToProfession.vue'
import ProfessionWideningDialog from '@/components/admin/widening/ToProfessionDialog.vue'
import filter from 'lodash/filter'
import _get from 'lodash/get'
import API from '@/services/api'

export default {
  data: () => ({
    profession: null,
    editDialog: false,
    editData: null
  }),

  components: {
    ProfessionWidening,
    ProfessionWideningDialog
  },

  computed: {
    ...mapGetters('basic', ['basicProfessions', 'getProfessionNameById', 'getProfessionById']),

    professions() {
      return filter(this.basicProfessions, ['isApplicationProfession', true])
    },

    professionName() {
      if (!this.profession) return null
      return _get(this, 'profession.name', null)
    },

    professionType() {
      if (!this.profession) return null
      return _get(this, 'profession.isMachineProfession', false) ? 'Maskinyrke' : 'Anläggningsyrke'
    },

    toProfessions() {
      if (!this.profession) return {}
      let toProfs = []
      let qtl = _get(this, 'profession.qualificationTimeLength',"{}")
      // Handle case where server don't return JSON
      if (typeof qtl === 'string') {
        qtl = JSON.parse(qtl)
      }
      for (var key of Object.keys(qtl)) {
        const tp = this.getProfessionById(Number(key))
        if (tp && tp.id !== this.profession.id) {
          toProfs.push( {
            profession: tp.id,
            professionName: tp.name,
            professionType: (tp.isMachineProfession ? 'Maskinyrke' : 'Anläggningsyrke'),
            fromProfessionName: this.professionName,
            data: qtl[key]
          })
        }
      }
      return toProfs.sort((a, b) => a.professionName.localeCompare(b.professionName));
    }
  },

  methods: {
    ...mapActions('basic', ['setProfessions']),

    showDialog(data) {
      this.editData = data
      this.editDialog = true
    },
    hideDialog() {
      console.log('hide')
      this.editData = null
      this.editDialog = false
    },

    async save(data) {
      //- Save
      
      // Handle case where server don't return JSON
      let qtl = _get(this, 'profession.qualificationTimeLength',"{}")
      if (typeof qtl === 'string') {
        qtl = JSON.parse(qtl)
      }

      const currentProfessionId = _get(this, 'profession.id',-1)

      qtl[String(data.profession)] = {
        length: data.months,
        requiredCourses: data.courses.map(i => { return  {id: i.value, name: i.text}})
      }

      await API.updateProfessions(
        currentProfessionId, 
        {
          data: {
            name: _get(this, 'profession.name',null), 
            qualificationTimeLength: qtl
          }
        }
      )

      //- Reload
      await API.listProfessions()
        .then(response => {
          return this.setProfessions(response.data)
        })
        .catch(error => {
          console.log('There was an error fetching professions:', error)
        })

      this.profession = null
      this.$nextTick(() => this.profession = this.getProfessionById(currentProfessionId))

      this.editDialog = false
    }
  }

}
</script>

<style scoped>

</style>